const selectors = {
  nav: '.nav',
  navControl: '.nav__control',
  navItem: '.nav__item',
  navLink: '.nav__link',
  navParent: '[data-nav-parent]',
  subnav: '[data-subnav]',
  toggle: '.nav__control',
};

const classes = {
  open: 'open',
};

const config = {
  mouseleaveDelay: 500,
};

const state = {
  activeSubmenu: null,
  closeQueue: [],
  returnFocusTo: null,
};

let timer;

const getSubmenu = (parent) => {
  return parent.querySelector(selectors.nav);
};

const closeAllSubmenus = () => {
  const { closeQueue } = state;

  if (!closeQueue) return;

  for (let i = closeQueue.length - 1; i >= 0; i--) {
    closeSubmenu(closeQueue[i]);
  }

  const { returnFocusTo } = state;
  returnFocusTo.focus();
};

const openSubmenu = (parent) => {
  const submenu = getSubmenu(parent);

  if (!submenu) return;

  const primaryNavTrigger = parent.querySelector(selectors.navControl);
  const isOpen = submenu.classList.contains(classes.open);

  if (isOpen) return;

  const toggle = parent.querySelector(selectors.toggle);
  submenu.classList.add(classes.open);
  toggle.setAttribute('aria-expanded', true);
  state.activeSubmenu = submenu;
  state.closeQueue.push(submenu);

  if (parent.classList.contains('nav__item--primary')) {
    state.returnFocusTo = primaryNavTrigger;
  }
};

const hideFromScreenReaderUsers = (submenu) => {
  const focusableElements = submenu.querySelectorAll('button, a');

  Array.from(focusableElements).forEach((element) => {
    element.setAttribute('tabindex', '-1');
  });

  submenu.setAttribute('aria-hidden', 'true');
};

const showForScreenReaderUsers = (submenu) => {
  const focusableElements = submenu.querySelectorAll('button, a');

  Array.from(focusableElements).forEach((element) => {
    element.setAttribute('tabindex', '0');
  });

  submenu.setAttribute('aria-hidden', 'false');
};

const closeSubmenu = (submenu) => {
  const { closeQueue } = state;
  closeQueue.pop();

  if (!submenu) return;
  const parent = submenu.closest(selectors.navParent);
  const toggle = parent.querySelector(selectors.toggle);

  // Adjust element attributes
  submenu.classList.remove(classes.open);
  toggle.setAttribute('aria-expanded', false);
  hideFromScreenReaderUsers(submenu);

  if (closeQueue.length > 0) {
    state.activeSubmenu = closeQueue[closeQueue.length - 1];
  } else {
    state.activeSubmenu = null;
  }
};

const handleControlClick = (event) => {
  const navControl = event.target.closest(selectors.navControl);

  if (!navControl) return;

  const expandedState = navControl.getAttribute('aria-expanded');
  const navParent = navControl.closest(selectors.navParent);

  if (!navParent) return;
  const submenu = navParent.querySelector(selectors.nav);

  if (expandedState === 'false') {
    openSubmenu(navParent);
    showForScreenReaderUsers(submenu);
  } else {
    closeSubmenu(submenu);
  }
};

const handleItemLeave = (event) => {
  const { relatedTarget, target } = event;
  const mouseleaveWasPartOfMenu = target.closest(selectors.nav);

  if (!mouseleaveWasPartOfMenu) return;

  if (relatedTarget) {
    const nav = relatedTarget.closest(selectors.nav);

    if (!nav) {
      timer = setTimeout(closeAllSubmenus, config.mouseLeaveDelay);
    }

    if (nav !== state.activeSubmenu) {
      closeSubmenu(state.activeSubmenu);
    }
  }
};

const handleItemEnter = (event) => {
  const { target } = event;
  const navParent = target.closest(selectors.navParent);

  if (!navParent) return;

  clearTimeout(timer);
  openSubmenu(navParent);
};

const init = () => {
  document.addEventListener('click', handleControlClick);
  document.addEventListener('mouseover', handleItemEnter);
  document.addEventListener('mouseout', handleItemLeave);
};

const navigationController = {
  init,
};

export default navigationController;
